import { navigate } from "gatsby";
import PropTypes from "prop-types";
import React, { useState } from "react";
import styled from "styled-components";

import {
  // getFontFamily,
  getSize,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import { Button } from "components/CallToAction";
import { CheckboxInput, CheckboxLabel } from "components/CheckboxLabel";

import { handleFormSubmit } from "utils/handle-form-submit";

import { BecomeADealer } from "./components/become-a-dealer";
import { DealerBenefits } from "./components/dealer-benefits";

import { Content, StyledForm, Input, MergedGridRow } from "./styles";

const Alert = styled.label`
  display: block;
  padding: 24px;
  margin: 0 0 19px 0;
  text-align: center;
  ${({
    error,
    theme: {
      colors: { red, pink },
    },
  }) => `
    background-color: ${pink};
    color: ${red};
    display: ${error ? "initial" : "none"};
  `}
`;

export const BecomeARacepointDealer = ({ action }) => {
  const [showError, setShowError] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  return (
    <div>
      <BecomeADealer />
      <Content>
        <DealerBenefits />
        <StyledForm
          action={action}
          enctype="application/x-www-form-urlencoded"
          method="post"
          onSubmit={(submitEvent) => {
            setShowError(false);
            setSubmitting(true);
            handleFormSubmit(
              function onSuccess() {
                setSubmitting(false);
                navigate("/become-a-savant-power-dealer/success#thankYou");
              },
              function onError() {
                setSubmitting(false);
                setShowError(true);
              }
            )(submitEvent);
          }}
          submitMessage="Thank you for your interest in becoming a Savant Power Dealer! A member of our team will be in contact soon."
        >
          <Alert htmlFor="submit" error={showError}>
            There was an error submitting your request. Please verify your data
            and try again.
          </Alert>
          <Input
            id="businessName"
            placeholder="Business Name*"
            name="businessName"
            required
            type="text"
          />
          <MergedGridRow
            css={`
              @media screen and (min-width: ${getSize("tablet720")}) {
                grid-template-columns: 1fr 1fr;
              }
            `}
          >
            <Input
              id="firstName"
              name="firstName"
              placeholder="First Name*"
              required
              type="text"
            />
            <Input
              id="lastName"
              name="lastName"
              placeholder="Last Name*"
              required
              width="50%"
              type="text"
            />
          </MergedGridRow>
          <Input
            id="email"
            name="email"
            placeholder="Email*"
            required
            type="email"
          />
          <Input
            id="address"
            name="address"
            placeholder="Business Address*"
            required
            type="text"
          />
          <Input
            id="addressContinued"
            name="addressContinued"
            placeholder="Business Address Continued"
            type="text"
          />
          <MergedGridRow
            css={`
              @media screen and (min-width: ${getSize("tablet720")}) {
                grid-template-columns: 1fr 0.4fr;
              }
            `}
          >
            <Input id="city" placeholder="City" name="city" type="text" />
            <Input
              id="state"
              name="state"
              placeholder="State/Province"
              type="text"
            />
          </MergedGridRow>
          <MergedGridRow
            css={`
              @media screen and (min-width: ${getSize("tablet720")}) {
                grid-template-columns: 0.4fr 1fr;
              }
            `}
          >
            <Input
              placeholder="Zip/Postal Code"
              id="zip"
              name="zip"
              type="text"
            />
            <Input
              id="country"
              placeholder="Country"
              name="country"
              type="text"
            />
          </MergedGridRow>
          <Input
            css={`
              @media screen and (min-width: ${getSize("default")}) {
                margin-top: 28px;
              }
              @media screen and (min-width: ${getSize("tablet960")}) {
                margin-top: 40px;
              }
              @media screen and (min-width: ${getSize("desktop1200")}) {
                margin-top: 26px;
              }
              @media screen and (min-width: ${getSize("desktop1920")}) {
                margin-top: 40px;
              }
            `}
            id="numberInstallationsPerYear"
            name="numberInstallationsPerYear"
            placeholder="Approximate installations per year*"
            required
            type="text"
          />
          <Input
            id="operationLocation"
            name="operationLocation"
            placeholder="Where do you operate?*"
            required
            type="text"
          />
          <CheckboxLabel htmlFor="sellsAutomationSystems">
            <CheckboxInput
              id="sellsAutomationSystems"
              name="sellsAutomationSystems"
              type="checkbox"
            />
            <span>
              {
                "Do you currently sell any home automation or load control systems?"
              }
            </span>
          </CheckboxLabel>
          <Input
            name="automationBrandsSold"
            id="automationBrandsSold"
            placeholder="If so, which brands?"
            type="text"
          />
          <CheckboxLabel htmlFor="sellsEnergySystems">
            <CheckboxInput
              id="sellsEnergySystems"
              name="sellsEnergySystems"
              type="checkbox"
            />
            {"Do you sell energy storage systems?"}
          </CheckboxLabel>
          <Input
            id="storageSystemsSold"
            name="storageSystemsSold"
            placeholder="If so, which brands?"
            type="text"
          />
          <div
            css={`
              margin-top: 30px;
              text-align: center;
              @media screen and (min-width: ${getSize("mobile480")}) {
                margin-top: 40px;
              }
              @media screen and (min-width: ${getSize("tablet720")}) {
                margin-top: 27px;
              }
              @media screen and (min-width: ${getSize("tablet960")}) {
                margin-top: 38px;
              }
              @media screen and (min-width: ${getSize("desktop1200")}) {
                margin-top: 28px;
              }
              @media screen and (min-width: ${getSize("desktop1920")}) {
                margin-top: 20px;
              }
            `}
          >
            <Button
              css={`
                @media screen and (min-width: ${getSize("desktop1920")}) {
                  border-width: 2px;
                  font-size: 16px;
                  padding: 20px 56px;
                }
              `}
              disabled={submitting}
              name="submit"
              type="submit"
            >
              submit
            </Button>
          </div>
        </StyledForm>
      </Content>
    </div>
  );
};

BecomeARacepointDealer.propTypes = {
  action: PropTypes.string,
};
